// extracted by mini-css-extract-plugin
export default {"wrapper":"uvQtH9","header":"qaR8DX","grid":"FXS_q6","footerText":"Mzk8sd"};